@if (!!carregouDados()) {
<!---->
@if(!detalhesTriagemMovIA() && !detalhesTriagemEquilibrIA()) {
<div class="sem-registro-container">
  <img src="../../../../assets/svg/icons/info_ic_azul.svg" alt="" />
  <p>
    A triagem tem como objetivo identificar informações relevantes sobre a saúde
    da pessoa e apoiar o acompanhamento realizado pela equipe de saúde. Esse
    processo ocorre após o cadastro da pessoa aqui na Plataforma, e ela deve ser
    orientada a realizar a triagem, que é conduzida com o suporte da assistente
    virtual Cindi, contando com interações ativas do participante. Após a
    conclusão, as respostas ficam disponíveis nesta aba para consulta pelo
    profissional de saúde.
    <br />
    Caso o formulário não esteja listado, significa que a pessoa ainda não
    realizou a triagem.
  </p>
</div>
}

<!---->
@if (!!detalhesTriagemMovIA()) {
<app-layout-cindi-movia
  [detalhesTriagem]="detalhesTriagemMovIA()"
></app-layout-cindi-movia>
}

<!---->
@if (!!detalhesTriagemEquilibrIA()) {
<app-layout-cindi-equilibria
  [detalhesTriagem]="detalhesTriagemEquilibrIA()"
></app-layout-cindi-equilibria>
} }
